var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.085 22V10.889m0 0c-1.856 0-3.36-1.492-3.36-3.333 0-1.841 1.504-3.334 3.36-3.334m0 6.667c1.856 0 3.36-1.492 3.36-3.333 0-1.841-1.504-3.334-3.36-3.334m0-2.222v2.222M4.36 2v11.111m0 0c-1.856 0-3.36 1.492-3.36 3.333 0 1.841 1.505 3.334 3.36 3.334m0-6.667c1.856 0 3.36 1.492 3.36 3.333 0 1.841-1.504 3.334-3.36 3.334m0 2.222v-2.222M19.64 2v8.95m0 0c-1.856 0-3.36 1.492-3.36 3.333 0 1.841 1.504 3.333 3.36 3.333m0-6.666c1.855 0 3.36 1.492 3.36 3.333 0 1.841-1.505 3.333-3.36 3.333m0 4.384v-4.384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.4b6b8fb265bde521a9d8d1c03edc38bd.svg";
export { ForwardRef as ReactComponent };